export default __webpack_public_path__ + "static/media/home-design-agency-img-07.d11d3cf5.jpg";